import { Anchor, Badge, Code, Flex, Grid, Table, Text } from "@mantine/core";
import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mantine";
import {
  DetailsCard,
  DetailsUserCard,
} from "components/common/show/DetailsPair";
import { History } from "components/common/show/History";
import { TeaAddon } from "entities/tea_addons";
import { Link } from "react-router-dom";

export const TeaAddonShow = () => {
  const { queryResult } = useShow<TeaAddon>();
  const { data, isLoading } = queryResult;
  const tea_addon = data?.data;

  if (!tea_addon) return <div />;

  return (
    <Show isLoading={isLoading}>
      <Grid>
        <Grid.Col span={8}>
          <Flex gap="sm" direction="column">
            <DetailsCard title="Notes">{tea_addon.notes}</DetailsCard>
            <History<TeaAddon>
              resources={"tea_addons"}
              entityId={tea_addon.id}
            />
          </Flex>
        </Grid.Col>
        <Grid.Col span={4}>
          <Flex direction="column" gap="sm">
            <DetailsUserCard user={tea_addon.user} />
            <DetailsCard title="ID">
              <Text>{tea_addon.id}</Text>
            </DetailsCard>
            <DetailsCard title="Name">
              <Text>{tea_addon.name}</Text>
            </DetailsCard>
            <DetailsCard title="Box Name">
              <Badge color="indigo">{tea_addon.box_name}</Badge>
            </DetailsCard>
            <DetailsCard title="Tea Addon Subscription">
              <Anchor
                component={Link}
                to={`/tea_addon_subscriptions/show/${tea_addon.tea_addon_subscription?.id}`}
              >
                {tea_addon.tea_addon_subscription?.id}
              </Anchor>
            </DetailsCard>
            <DetailsCard title="Invoice">
              <Anchor
                component={Link}
                to={`/invoices/show/${tea_addon.invoice?.id}`}
              >
                {tea_addon.invoice?.remote_id}
              </Anchor>
            </DetailsCard>
            <DetailsCard title="Order Invoice">
              <Anchor
                component={Link}
                to={`/invoices/show/${tea_addon.order_invoice?.id}`}
              >
                {tea_addon.order_invoice?.remote_id}
              </Anchor>
            </DetailsCard>
            <DetailsCard title="Shippable At">
              <Code>{tea_addon.shippable_at?.toString()}</Code>
            </DetailsCard>
            <DetailsCard title="Created At">
              <Code>{tea_addon.created_at?.toString()}</Code>
            </DetailsCard>
            <DetailsCard title="Updated At">
              <Code>{tea_addon.updated_at?.toString()}</Code>
            </DetailsCard>
          </Flex>
        </Grid.Col>
      </Grid>
    </Show>
  );
};
